// extracted by mini-css-extract-plugin
export default {"table":"table__Qy33u","addButton":"addButton__isVRk","error":"error__zRlEK","actions":"actions__RDHXW"};